<template lang="pug">
  footer.cols.px3.sm-px2.items-center.bg-white
    .col.sm-display-none
      span.cursor-pointer(@click="$emit('click')") View Series
    .col.center.sm-left-align
      active-title(:project="project")
    .col.right-align
      span {{index}}/{{length}}
</template>

<script>
import ActiveTitle from '@/components/SeriesViewerFooter__ActiveTitle'
export default {
  name: 'ViewerFooter',
  props: ['project', 'index', 'length'],
  components: { ActiveTitle }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SeriesViewerFooter.vue